import { OPS_SOLUTION_PATHS, USE_CASE_PATHS } from 'modules/solutions/solutionUrls'

export const opsSolutions = [
  {
    title      :'Rise and shine to your startup operating at peak efficiency.',
    description:'Our superhuman team maximizes your impact at every stage of the startup journey—from discovering early customers and fundraising to hiring your founding team.',
    path       :OPS_SOLUTION_PATHS.FOR_STARTUP_FOUNDERS,
  },
  {
    title      :'Hyper-targeted B2B lead generation to scale your top-of-funnel.',
    description:'Maximize your sales and marketing efforts with qualified B2B leads, custom generated in 24 hours by our AI-powered expert team.',
    path       :OPS_SOLUTION_PATHS.B2B_LEAD_GENERATION,
  },
  {
    title      :'Improve your outreach results with comprehensive B2B data enrichment.',
    description:'Boost your sales, marketing, and overall outreach efforts with Pareto\'s team of data experts, optimized workflows, and top-tier B2B data enrichment services.',
    path       :OPS_SOLUTION_PATHS.B2B_DATA_ENRICHMENT,
  },
  {
    title      :'Find social media influencers with top engagement to drive your brand marketing campaigns.',
    description:'Amplify your brand with custom lists of target influencers across Instagram, TikTok, and other social media platforms, sourced in 24 hours by our AI-powered expert team.',
    path       :OPS_SOLUTION_PATHS.FIND_INFLUENCERS,
  },
  {
    title      :'Uncover hidden treasures in your market with our research.',
    description:'Leverage key insights from quality data, drive business growth, enhance strategic planning, and master your market with Pareto\'s market research services.',
    path       :OPS_SOLUTION_PATHS.MARKET_RESEARCH,
  },
  {
    title      :'Easy Data Migration',
    description:'Migrate your data between platforms, databases, and systems with Pareto\'s seamless data migration services.',
    path       :OPS_SOLUTION_PATHS.DATA_MIGRATION,
  },
  {
    title      :'Drive startup growth success with a tailored VC list.',
    description:'Propel your startup\'s growth by connecting with top - tier VC firms using lists of contacts custom- generated by our superhuman, expert team.',
    path       :OPS_SOLUTION_PATHS.FIND_VC_INVESTORS,
  },
  {
    title      :'Find angel investors to fund your startup with a custom list of value-add angels.',
    description:'Secure funding from actively investing angels and industry experts with lists of contacts, custom generated in 24 hours by our AI-powered expert team.',
    path       :OPS_SOLUTION_PATHS.FIND_ANGEL_INVESTORS,
  },
  {
    title      :'Source top candidates fast and hire your dream team in weeks, not months.',
    description:'Find passive candidates in 24 hours with our AI-powered expert team.',
    path       :OPS_SOLUTION_PATHS.FIND_CANDIDATES_FOR_OPEN_ROLES,
  },
]

export const useCases = [
  {
    image      :'/misc/rlhf.png',
    title      :'RLHF',
    description:'We provide human feedback on a model\'s output through demonstrations, evaluations, or ranking of its generated results.',
    path       :USE_CASE_PATHS.RLHF,
  },
  {
    image      :'/misc/reinforcement-learning.png',
    title      :'Side-by-side model comparison',
    description:'We evaluate and rank outputs across multiple models based on accuracy, relevance, and quality to determine the best-performing model.',
    path       :USE_CASE_PATHS.SIDE_BY_SIDE_RL,
  },
  {
    image      :'/misc/original-content-generation.png',
    title      :'Unique original content',
    description:'We create and collect unique prompts and demonstrations of ideal responses across hundreds of categories to train creativity and originality.',
    path       :USE_CASE_PATHS.ORIGINAL_CONTENT,
  },
  {
    image      :'/misc/llm-hallucination-testing.png',
    title      :'Creative hallucination inducement',
    description:'We apply creative strategies to induce models to break rules and determine the areas that need improvement.',
    path       :USE_CASE_PATHS.CREATIVE_HALLUCINATION,
  },
  {
    image      :'/misc/ai-factuality-training.png',
    title      :'Honesty and factuality training',
    description:'We evaluate a model\'s outputs, provide feedback, and ensure that the model\'s responses are both honest and factual.',
    path       :USE_CASE_PATHS.HONESTY_FACTUALITY_TRAINING,
  },
  {
    image      :'/misc/ai-safety-ethics-training.png',
    title      :'AI safety, compliance, and ethics training',
    description:'We find problematic, adversarial, harmful, and illegal behavior by models and provide feedback as needed.',
    path       :USE_CASE_PATHS.SAFETY_ETHICS_COMPLIANCE,
  },
  {
    image      :'/misc/engine-annotation.png',
    title      :'In-depth engine annotation',
    description:'We annotate every step of the LLM process, from data labeling, training & fine-tuning, quality control, human-in-the-loop feedback, and evaluation.',
    path       :USE_CASE_PATHS.ENGINE_ANNOTATION,
  },
  {
    image      :'/misc/classification.png',
    title      :'Classification',
    description:'We classify and compare LLM data, including text, images, audio questions, and prompts.',
    path       :USE_CASE_PATHS.CLASSIFICATION,
  },
  {
    image      :'/misc/prompt-creation.png',
    title      :'Prompt creation',
    description:'We craft highly effective prompts that stimulate creative responses from LLMs, generating original and engaging content for various applications.',
    path       :USE_CASE_PATHS.LLM_PROMPTING,
  },
  {
    image      :'/misc/term-relevancy.png',
    title      :'Term relevancy and item fluency grading',
    description:'We ensure that the LLM\'s outputs are both contextually relevant and fluently constructed.',
    path       :USE_CASE_PATHS.LLM_FLUENCY_RELEVANCY_GRADING,
  },
  {
    image      :'/misc/language-segmentation.png',
    title      :'Language segmentation',
    description:'We identify, validate, and correct errors in segmented text units, ensuring the engine refines segmentation and extracts key terms accurately.',
    path       :'',
  },
  {
    image      :'/misc/data-labeling-dataset-creation.png',
    title      :'Data labeling and dataset creation',
    description:'We precisely label and create expertly-curated foundational data to streamline model training and optimize output.',
    path       :'',
  },
]

export const spadeMap = [
  'Get more customers',
  'Scale niche marketing',
  'Recruit your dream team',
  'Discover relevant investors',
  'Automate recurring tasks',
  'Iterate fast on product',
]
